import { store } from '../app';

const plugins = [
  ...store.plugins,
];

export default plugins;



// WEBPACK FOOTER //
// ./src/store/plugins.js